import { BlocksIconFacebook } from 'blocks-nextjs/blocks-web-components/components/icon/icons/facebook';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconFacebook = createComponent({
  react: React,
  tagName: 'cat-icon-facebook',
  elementClass: BlocksIconFacebook
});
